import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateWarrantyStatusMutationVariables = Types.Exact<{
  applicationId: Array<Types.Scalars['Long']['input']> | Types.Scalars['Long']['input'];
  status: Types.Scalars['String']['input'];
  updateBy: Types.Scalars['String']['input'];
}>;


export type UpdateWarrantyStatusMutation = { __typename?: 'Mutation', updateWarrantyStatus: { __typename?: 'ResultResponse', count: number, error?: string | null } };


export const UpdateWarrantyStatusDocument = gql`
    mutation UpdateWarrantyStatus($applicationId: [Long!]!, $status: String!, $updateBy: String!) {
  updateWarrantyStatus(
    parameter: {applicationId: $applicationId, status: $status, updateBy: $updateBy}
  ) {
    count
    error
  }
}
    `;
export type UpdateWarrantyStatusMutationFn = Apollo.MutationFunction<UpdateWarrantyStatusMutation, UpdateWarrantyStatusMutationVariables>;

/**
 * __useUpdateWarrantyStatusMutation__
 *
 * To run a mutation, you first call `useUpdateWarrantyStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWarrantyStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWarrantyStatusMutation, { data, loading, error }] = useUpdateWarrantyStatusMutation({
 *   variables: {
 *      applicationId: // value for 'applicationId'
 *      status: // value for 'status'
 *      updateBy: // value for 'updateBy'
 *   },
 * });
 */
export function useUpdateWarrantyStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWarrantyStatusMutation, UpdateWarrantyStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWarrantyStatusMutation, UpdateWarrantyStatusMutationVariables>(UpdateWarrantyStatusDocument, options);
      }
export type UpdateWarrantyStatusMutationHookResult = ReturnType<typeof useUpdateWarrantyStatusMutation>;
export type UpdateWarrantyStatusMutationResult = Apollo.MutationResult<UpdateWarrantyStatusMutation>;
export type UpdateWarrantyStatusMutationOptions = Apollo.BaseMutationOptions<UpdateWarrantyStatusMutation, UpdateWarrantyStatusMutationVariables>;